import './components/methods';
import './components/imask';
import './components/slider';
import './components/modal';
import './components/tabs';
import './components/accordion';
// import './components/aos';
// import './vendor/jquery';
// import './components/parallax';
